class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.inventoryCache = {};
    this.cachedLatLng = null;
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.loadCartInventory();
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
      this.inventoryCache = {};
      this.loadCartInventory();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  async getLatLngFromSelectedStore() {
    if (this.cachedLatLng) return this.cachedLatLng;

    const saved = localStorage.getItem("selectedStore");
    if (!saved) return null;

    const store = JSON.parse(saved);
    const address = store.name;

    if (!address) return null;

    return new Promise((resolve) => {
      if (!window.google || !google.maps) {
        resolve(null);
        return;
      }

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address }, (results, status) => {
        if (status !== "OK") {
          resolve(null);
          return;
        }

        const loc = results[0].geometry.location;

        this.cachedLatLng = {
          lat: loc.lat(),
          lng: loc.lng(),
        };
        console.log(this.cachedLatLng);
        resolve(this.cachedLatLng);
      });
    });
  }
  async loadCartInventory() {
    const location = await this.getLatLngFromSelectedStore();

    const lat = location?.lat || 0;
    const lon = location?.lng || 0;

    const items = this.querySelectorAll(".cart-item");

    items.forEach(async (item) => {
      const sku = item.dataset.sku;
      if (!sku) return;

      // ✅ 缓存
      if (sku in this.inventoryCache) {
        this.renderInventory(item, this.inventoryCache[sku]);
        return;
      }

      try {
        const res = await fetch(
          "https://shopify-big.bigcaring.com.my/api/outlet/available",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              sku,
              quantity: 1,
              lat,
              lon,
              count: 5,
            }),
          },
        );

        const data = await res.json();
        const list = data.avaliable || data.available || [];
        const outlet = list[0] || null;
        
        this.inventoryCache[sku] = outlet;
        
        this.renderInventory(item, outlet);
      } catch (err) {
        console.error(err);
      }
    });
  }
  renderInventory(item, outlet) {
    let el = item.querySelector(".cart-item__inventory");
  
    if (!el) {
      el = document.createElement("div");
      el.className = "cart-item__inventory";
      item.querySelector(".cart-item__details")?.appendChild(el);
    }
  
    let store = null;
    try {
      store = JSON.parse(localStorage.getItem("selectedStore"));
    } catch (e) {
      store = null;
    }
  
    if (!store || !store.name) return;
  
    // ✅ 根据 outlet 是否存在判断文案
    if (!outlet) {
      el.innerHTML = `
        <span style="color:red;font-size:12px;">
          Pickup unavailable at ${store.name}
        </span>
      `;
    } else {
      el.innerHTML = `
        <span style="color:#000;font-size:12px;">
          Pickup available at ${store.name}
        </span>
      `;
    }
  }
  updateSelectedStore(storeData) {
    // 存储
    localStorage.setItem("selectedStore", JSON.stringify(storeData));
    console.log('1111')
    // 刷新 cart
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
      cartDrawer.cachedLatLng = null;
      cartDrawer.inventoryCache = {};
      cartDrawer.loadCartInventory();
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
